module.exports = __webpack_public_path__ + "static/media/Hungary.9f9c1255.jpg";